<template>
    <div class="activity">
        <el-form :model="searchData" :inline="true" size="small">
            <el-form-item>
                <el-input v-model="searchData.name" placeholder="活动名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain icon="el-icon-search" @click="GetSearch"
                    >搜索</el-button
                >
            </el-form-item>
        </el-form>
        <div class="card">
            <div class="list" v-loading="raffleData.loading.list">
                <el-row class="list-control">
                    <el-col :span="24" class="t-right">
                        <el-button
                            type="primary"
                            size="small"
                            icon="el-icon-circle-plus"
                            @click="GetDetail"
                            >活动</el-button
                        >
                    </el-col>
                </el-row>
                <div class="list-table">
                    <el-table
                        ref="customerTable"
                        :data="raffleData.list"
                        stripe
                        style="width: 100%"
                    >
                        <el-table-column prop="id" label="ID" width="60"></el-table-column>
                        <el-table-column label="名称" width="240">
                            <template slot-scope="scope">
                                <el-link
                                    type="primary"
                                    :underline="false"
                                    @click="DetailRaffle(scope.row)"
                                    >{{ scope.row.title }}</el-link
                                >
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="starttime"
                            label="开始时间"
                            width="240"
                        ></el-table-column>
                        <el-table-column
                            prop="starttime"
                            label="结束时间"
                            width="240"
                        ></el-table-column>
                        <el-table-column prop="remarks" label="备注"></el-table-column>
                        <el-table-column width="80">
                            <template slot-scope="scope">
                                <el-button size="mini" @click="DelRaffle(scope.row)"
                                    >删除</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="list-pagination">
                    <el-pagination
                        background
                        layout="total, prev, pager, next, sizes"
                        :current-page.sync="raffleData.pages.page"
                        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                        :page-size="raffleData.pages.pagesize"
                        :total="raffleData.pages.total"
                        @size-change="GetSize"
                        @current-change="GetCurrent"
                    ></el-pagination>
                </div>
            </div>
        </div>

        <v-RaffleForm
            :componentData="componentData.raffleForm"
            v-if="componentData.raffleForm.visible"
        />
    </div>
</template>

<script>
import RaffleForm from '@/components/raffle/Form'
export default {
    components: {
        'v-RaffleForm': RaffleForm
    },
    inject: ['reload'],
    data() {
        return {
            searchData: {
                name: null
            },
            raffleData: {
                loading: {
                    list: false
                },
                list: [],
                pages: {
                    page: 1,
                    pagesize: 10,
                    total: 0
                }
            },
            componentData: {
                raffleForm: {
                    visible: false,
                    row: null
                }
            }
        }
    },
    created() {
        this.$nextTick(() => {})
    },
    mounted() {
        this.$nextTick(() => {
            this.GetList()
        })
    },
    methods: {
        GetDetail() {
            this.componentData.raffleForm = {
                visible: true
            }
        },
        GetSearch() {
            this.raffleData.pages.page = 0
            this.GetList()
        },
        GetList() {
            this.raffleData.loading.list = true
            this.$request({
                url: '/api/v1/getluckdrawlist',
                method: 'POST',
                data: {
                    ...this.searchData,
                    ...this.raffleData.pages
                }
            }).then(res => {
                if (!res.status) {
                    this.raffleData.loading.list = false
                    this.raffleData.list = res.data.list
                    this.raffleData.pages.total = parseInt(res.data.total)
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        },
        GetSize(val) {
            this.raffleData.pages.pagesize = val
            this.GetList()
        },
        GetCurrent(val) {
            this.raffleData.pages.page = val
            this.GetList()
        },
        DetailRaffle(row) {
            this.componentData.raffleForm = {
                visible: true,
                row: row
            }
        },
        DelRaffle(row) {
            this.$confirm('此操作将永久删除当前数据, 是否继续?', '警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.raffleData.loading.list = true
                    this.$request({
                        url: '/api/v1/delluckdraw',
                        method: 'POST',
                        data: {
                            id: row.id
                        }
                    }).then(res => {
                        this.$message({
                            message: res.message || (res.status ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                        if (!res.status) {
                            this.GetSearch()
                        }
                    })
                })
                .catch(() => {})
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/card.less';
@import '~@/assets/css/list.less';
</style>
